module.exports = __webpack_public_path__ + "img/openingPark.2287cfdb.png";